// ConfirmDialog.tsx
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
    onConfirm: () => void;
    onClose: () => void;
}

const CommonStatus: React.FC<ConfirmDialogProps> = ({
    open,
    title = "Confirm Action",
    message = "Are you sure?",
    confirmColor = "error",
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
    onClose,
}) => {
    return (
        <Dialog open={open} className="my-dialog"
            onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{message}</DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{cancelText}</Button>
                <Button color={confirmColor} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CommonStatus;
